import React, { useState } from 'react';
import SelectField from '../../Forms/Input/SelectField';
import InputField from '../../Forms/Input/InputField';
import { CashClosureHistoryFilters as FiltersType } from '../../../services/cash/CashClosureHistoryService';

interface BranchOption {
  id: number;
  name: string;
}

interface Props {
  branches: BranchOption[];
  onSearch: (filters: FiltersType) => void;
  onReset: () => void;
}

const CashClosureHistoryFilters: React.FC<Props> = ({
  branches,
  onSearch,
  onReset,
}) => {
  const [branchId, setBranchId] = useState<string | number>('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleSearch = () => {
    onSearch({
      branchId: branchId ? Number(branchId) : undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    });
  };

  const handleReset = () => {
    setBranchId('');
    setFromDate('');
    setToDate('');
    onReset();
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      <SelectField
        label="Sucursal"
        name="branchId"
        value={branchId}
        onChange={(e) => setBranchId(e.target.value)}
        options={[
          { value: '', label: 'Todas' },
          ...branches.map((b) => ({ value: b.id, label: b.name })),
        ]}
        iconKey="branch"
      />

      <InputField
        label="Desde"
        name="fromDate"
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        iconKey="calendar"
      />

      <InputField
        label="Hasta"
        name="toDate"
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        iconKey="calendar"
      />

      <div className="flex items-end gap-2">
        <button
          onClick={handleSearch}
          className="h-[46px] flex-1 rounded-md bg-primary px-4 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Buscar
        </button>

        <button
          onClick={handleReset}
          className="h-[46px] rounded-md border border-stroke px-4 text-sm text-black hover:bg-gray-100 dark:border-strokedark dark:text-white dark:hover:bg-meta-4"
        >
          Limpiar
        </button>
      </div>
    </div>
  );
};

export default CashClosureHistoryFilters;
